import { cssVarColors } from 'lib/cssSelector'

const { main } = cssVarColors
export const defaultTrasition = {
  transition: 'all .2s ease'
}

export const defaultBorderWidth = '1px'

export const onHoverStyle = {
  base: {
    ...defaultTrasition,
    border: `${defaultBorderWidth} solid transparent`
  },
  active: {
    borderColor: main
  }
}
